import { render } from "./IconNotFound.vue?vue&type=template&id=031438e2"
import script from "./IconNotFound.vue?vue&type=script&lang=ts"
export * from "./IconNotFound.vue?vue&type=script&lang=ts"
script.render = render

export default script